import * as fieldMsgs from 'constants/formFieldsMessages';

export const validateFileList = (_, files) => {
  if (!files?.fileList?.length) return Promise.reject(Error(fieldMsgs.ERR_SAMPLE_FIELD_REQUIRED));
  return Promise.resolve();
};

export const validateMin = (min) => (_, value) => {
  if (!value || value < min) return Promise.reject(Error('Cantidad no válida'));
  return Promise.resolve();
};
